module.exports = __webpack_public_path__ + "static/media/Elfin.696cef6a.png";